document.addEventListener('DOMContentLoaded', function () {
    overrideText();
});

function overrideText() {
    let checkbox = document.querySelector('.custom-text-toggle [type="checkbox"]');
    checkbox?.addEventListener('change', function () {
    console.log("adding text field override");
    const input = document.querySelector('.custom-text-field [type="text"]');
    if (!input) return;

    input.addEventListener('input', function () {
        const nonSpaceChars = this.value.replace(/ /g, '');
        if (nonSpaceChars.length > 10) {
        let count = 0;
        let truncated = '';
        for (const char of this.value) {
            if (char === ' ') {
            truncated += char;
            } else if (count < 10) {
            truncated += char;
            count++;
            }
        }
        this.value = truncated;
        }
        console.log("input value:", this.value);
    });
    }, { once: true });

    if(!checkbox) {
        console.warn("Custom text toggle checkbox not found.");
        setTimeout(overrideText, 1000); // Retry after 1 second
    }
};